<template>
  <div class="parking-management-bg">
    <div v-if="currentScreen === 'cancell'" class="cancel-container">
    <div v-if="!isSubmissionSuccess" class="form-content">

      <h3 class='page-title'>退租登記</h3>
      <p class="title-description">退租車位需填寫以下表格內容，再送出登記</p>

      <!-- 退租登记表单 -->
      <div class="form-card">
        <h4 class="sub-title">月票退租申請(*號為必填欄位)</h4>
        <div class="two-columns">
          <div class="form-group">
            <label for="name">
              <span class="required-asterisk">*</span>
              姓名</label>
            <input type="text" id="name" v-model="name" placeholder="輸入姓名" required class="font-control" />
          </div>
          <div class="form-group">
            <label for="carNumber">
              <span class="required-asterisk">*</span>
              車號</label>
            <input type="text" id="carNumber" v-model="carNumber" @input="handleCarNumberInput" @blur="checkCarNumber" placeholder="範例：ABC1234(不需加上'-'符號)" required
              autocomplete="off" maxlength="7" class="font-control" />
            <p v-if="plateCheckStatus === 'checking'" class="plate-check-msg checking">車號查詢中…</p>
            <p v-else-if="plateCheckStatus === 'match'" class="plate-check-msg match">已查到您的月票紀錄</p>
            <p v-else-if="plateCheckStatus === 'notmatch'" class="plate-check-msg notmatch">未查詢到您月票之記錄，請確認車號是否正確</p>
          </div>
          <div class="form-group">
            <label for="phone">
              <span class="required-asterisk">*</span>

              聯絡電話</label>
            <input type="text" id="phone" v-model="phone" placeholder="範例：0920" required class="font-control" />
          </div>
          <div class="form-group">
            <label for="email">
              <span class="required-asterisk">*</span>

              電子郵件</label>
            <input type="email" id="email" v-model="email" placeholder="輸入電子郵件" required class="font-control" />
          </div>

          <div class="form-group">
            <label for="idNumber">
              <span class="required-asterisk">*</span>

              身分證字號/統一編號</label>
            <input type="text" id="idNumber" v-model="idNumber" placeholder="若為法人請填入統一編號" required
              class="font-control" />
          </div>
          <div class="form-group">
            <label for="parkingType">
              <span class="required-asterisk">*</span>
              退租原因</label>
            <select id="parkingType" v-model="parkingType" required class="font-control">
              <option value="" disabled>請選擇退租原因</option>
              <option v-for="r in refundReasons" :key="r.code" :value="r.code">{{ r.label }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 付款信息表单 -->
      <div class="form-card">
        <h4 class="sub-title">匯款資料(*號為必填欄位)</h4>

        <div class="two-columns">
          <div class="form-group account-name-group">
            <label for="accountName">
              <span class="required-asterisk">*</span>

              戶名<span class="label-note">（需與承租人姓名相同）</span></label>
            <input type="text" id="accountName" v-model="accountName" placeholder="輸入戶名" required
              class="font-control" />
          </div>
          <div class="form-group bank-code-group">
            <label for="bankCode">
              <span class="required-asterisk">*</span>
              銀行代碼 
              <a v-if="False" style="margin-left:1rem;" 
              href="https://www.fisc.com.tw/TC/Service?Caid=51254999-5d15-4ddf-8e54-4b2cdb2a8399&CaStyleId=16"
              target="_blank" 
              rel="noopener noreferrer">
              
                點此查詢銀行及分行代碼</a>
            </label>
            <select id="bankCode" v-model="bankCode" required class="form-select font-control">
              <option value="" disabled selected>請選擇銀行</option>
              <option v-for="bank in bankList" :key="bank.code" :value="bank.code">
                {{ bank.code }} - {{ bank.name }}
              </option>
            </select>
          </div>

          <div class="form-group account-number-group">
            <label for="accountNumber">
              <span class="required-asterisk">*</span>
              匯款帳號11~14碼：<span class="label-note">(需與戶名及身分證相同之帳號)</span></label>
              <input
              type="text"
              id="accountNumber"
              v-model="accountNumber"
              placeholder="請輸入帳號"
              maxlength="14"
              inputmode="numeric"
              pattern="[0-9]*"
              @input="accountNumber = accountNumber.replace(/[^0-9]/g,'')"
              required
              class="font-control"
            />
          </div>

          <div class="form-group branch-code-group">
            <label for="branchCode">
              <span class="required-asterisk">*</span>
              分行代碼<span class="label-note">（請選擇您當初開戶的分行）</span></label>
            <select id="branchCode" v-model="branchCode" required class="form-select font-control">
              <option value="" disabled selected>請選擇原開戶分行</option>
              <option v-for="branch in filteredBranches" :key="branch[0]" :value="branch[0]">
                {{ branch[0] }} - {{ branch[1] }}
              </option>
            </select>
          </div>          
        </div>

      </div>
      <div class="form-card">

        <!-- 图形验证码 -->
        <div class="form-group">
          <label for="verificationCode">圖形驗證碼</label>
          <div class="two-columns">
            <input type="text" id="verificationCode" v-model="verificationCode" placeholder="請輸入驗證碼"
              class="font-control">

            <CaptchaComponent @update-captcha-code="updateCaptchaCode" />

          </div>
        </div>

        <div class="agreement-section">
          <div class="agreement-check">
            <input type="checkbox" id="agreement" v-model="isAgreed" />
            <label for="agreement">我已了解並同意相關事項</label>
          </div>
          <ul>
            <li>
              本人同意由“台灣聯通停車場開發股份有限公司”代為處理發票及銷貨退回證明單，
              以利加速退貨、退款作業。
            </li>
            <li>
              本申請單由客服專員電話確認後始可生效，
              並經由客服專員確認退租申請單成立時，原押金收據失效。
            </li>
          </ul>
        </div>

      </div>

      <!-- <div class="submit-btns">
          <button type="reset" class="reset-button">重填</button>
          <button type="submit" class="submit-button">送出登記</button>
        </div> -->

    </div>
    <!-- 表单内容 -->
    <div class="submit-btns">
      <button type="reset" class="form-submit-btn reset-button">重填</button>
      <button type="button" class="form-submit-btn" @click="handleSubmit">送出登記</button>
    </div>

    <!-- 匯款資料確認視窗：驗證通過後、實際送出前強制再次核對。
         客訴常見帳號碼數寫錯、分行未選原開戶分行，退匯需扣第二次手續費 $30 -->
    <div v-if="showBankConfirm" class="bank-confirm-overlay">
      <div class="bank-confirm-box">
        <h4 class="bank-confirm-title">送出前，請再次核對匯款資料</h4>

        <div class="bank-confirm-fields">
          <div class="bank-confirm-field">
            <span class="bank-confirm-label">銀行</span>
            <span class="bank-confirm-value"><span class="code-part">{{ bankCode }}</span>{{ selectedBankName }}</span>
          </div>
          <div class="bank-confirm-field">
            <span class="bank-confirm-label">分行（原開戶分行）</span>
            <span class="bank-confirm-value"><span class="code-part">{{ branchCode }}</span>{{ selectedBranchName }}</span>
          </div>
          <div class="bank-confirm-field">
            <span class="bank-confirm-label">受款戶名</span>
            <span class="bank-confirm-value">{{ accountName }}</span>
          </div>
          <div class="bank-confirm-field">
            <span class="bank-confirm-label">帳號（共 {{ accountNumber.length }} 碼）</span>
            <span class="bank-confirm-value account-value">{{ accountNumber }}</span>
          </div>
        </div>

        <p v-if="accountNumber.length < 11" class="bank-confirm-short">
          您的帳號僅 {{ accountNumber.length }} 碼（一般為 11~14 碼），請確認是否漏填。
        </p>

        <p class="bank-confirm-notice">
          請務必核對存摺！<br>
          若因帳號填寫錯誤導致匯款失敗，<br>
          款項退回將會扣除第二次匯款手續費 $30 元。
        </p>

        <div class="bank-confirm-btns">
          <button type="button" class="form-submit-btn" :disabled="isSubmitting" @click="confirmAndSubmit">
            {{ isSubmitting ? '送出中…' : '確認無誤，送出' }}
          </button>
          <button type="button" class="form-submit-btn reset-button" :disabled="isSubmitting" @click="backToEdit">
            返回修改
          </button>
        </div>
      </div>
    </div>
    </div>

    <CancelSuccess v-if="currentScreen === 'success'" />


    <ContactFooter />
  </div>
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';
import CaptchaComponent from '@/components/CaptchaComponent.vue';
import CancelSuccess from './CancelSuccess.vue';
import PullDAO from '@/services/PullDAO';
import { getBanksAsObjects } from '@/utils/bankData';
import { getBranchesByBankCode } from '@/utils/branches'; // Ensure this import is present

export default {
  name: 'UserCancel',
  components: {
    ContactFooter,
    CaptchaComponent, // 注册 CaptchaComponent 组件
    CancelSuccess,
  },
  data() {
    return {
      idNumber: '',
      parkingType: '', // 退租原因代碼（送 API 的 refreason）
      // 退租原因選項：對應 taiwanp.tp_refundreason，也是 refund_rent_API 的 refReasondic 支援的代碼
      // 送非代碼的文字會讓後端 refReasondic[refReason] KeyError，導致寫入成功卻回 cant send mail
      refundReasons: [
        { code: '01', label: '服務態度' },
        { code: '02', label: '調(離)職' },
        { code: '03', label: '出國' },
        { code: '04', label: '搬家' },
        { code: '05', label: '月租較高' },
        { code: '06', label: '機械故障率高' },
        { code: '07', label: '停車次數少改臨停' },
        { code: '08', label: '自購車位或已配車位' },
        { code: '09', label: '地點太遠' },
        { code: '10', label: '賣車或不用車' },
        { code: '11', label: '私人因素' },
        { code: '12', label: '公司不支付停車費' },
        { code: '13', label: '轉聯通他場' },
        { code: '14', label: '短期承租' },
        { code: '20', label: '專案到期' },
      ],
      name: '',
      carNumber: '',
      phone: '',
      email: '',
      accountName: '',
      bankCode: '',
      branchCode: '',
      accountNumber: '',
      verificationCode: '', // 用户输入的验证码
      captchaCode: '',      // 生成的验证码
      pullDAO: new PullDAO(), // PullDAO 实例
      bankList: getBanksAsObjects(), // 从 bankData.js 获取银行列表

      isAgreed: false, // 是否同意相关事项
      currentScreen: 'cancell', // 当前屏幕

      // 車號即時檢核：'' | 'checking' | 'match' | 'notmatch' | 'error'
      plateCheckStatus: '',
      plateCheckSeq: 0, // 防止先發後至的查詢結果覆蓋新結果

      // 匯款資料確認視窗：驗證通過後先核對銀行/分行/戶名/帳號，確認才真正送出
      showBankConfirm: false,
      isSubmitting: false, // 防止確認視窗上重複點擊送出
    };
  },
  computed: {
    filteredBranches() {
      console.log('Filtering branches for bank code:', this.bankCode);
      console.log ('getBranchesByBankCode(this.bankCode)', getBranchesByBankCode(this.bankCode))
      return this.bankCode ? getBranchesByBankCode(this.bankCode) : [];
    },

    // 確認視窗顯示用：代碼對應的銀行／分行名稱
    selectedBankName() {
      const b = this.bankList.find((x) => x.code === this.bankCode);
      return b ? b.name : '';
    },
    selectedBranchName() {
      const b = this.filteredBranches.find((x) => x[0] === this.branchCode);
      return b ? b[1] : '';
    },
  },
  watch: {
    bankCode() {
      // Reset branch code when bank code changes
      this.branchCode = '';
    }
  },
  methods: {
    handleCarNumberInput() {
      let value = this.carNumber;
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      this.carNumber = value;
      this.plateCheckStatus = ''; // 車號變動後舊的檢核結果不再有效
    },

    // 將退租相關 API 的請求／回應寫入 192.168.0.165 的 web-app-db.api_logs
    // best-effort：不 await、失敗只記 console，絕不影響退租流程
    logApiCall(entry) {
      const logUrl = process.env.VUE_APP_REFUND_LOG_API_URL;
      if (!logUrl) return;
      fetch(`${logUrl}/log`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(entry),
      }).catch((e) => console.warn('api_logs 記錄失敗（不影響流程）:', e));
    },

    // 車號即時檢核：呼叫 refund_rent_API 的 /get_post_guicompare_data
    // 回應為純文字 "OK"（查到月票）或 "not match"（查無資料）
    // API 連不上或回應無法辨識時不擋流程（fail-open），僅在明確查無資料時提示/攔截
    async checkCarNumber() {
      const carNumber = this.carNumber.trim();
      if (!carNumber) {
        this.plateCheckStatus = '';
        return;
      }

      const baseUrl = process.env.VUE_APP_REFUND_CHECK_API_URL;
      if (!baseUrl) {
        this.plateCheckStatus = '';
        return;
      }

      const seq = ++this.plateCheckSeq;
      this.plateCheckStatus = 'checking';

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      try {
        // 不設 Content-Type，維持 simple request 避免 CORS preflight；
        // 後端 get_json(force=True) 不看 Content-Type
        const response = await fetch(`${baseUrl}/get_post_guicompare_data`, {
          method: 'POST',
          body: JSON.stringify({ gui: carNumber }),
          signal: controller.signal,
        });
        const text = (await response.text()).trim();
        this.logApiCall({
          api_name: 'refund_plate_check',
          method: 'POST',
          url: `${baseUrl}/get_post_guicompare_data`,
          request_data: { gui: carNumber },
          response_data: text,
          status_code: response.status,
        });
        if (seq !== this.plateCheckSeq) return; // 已有更新的查詢，捨棄本次結果

        if (text === 'OK') {
          this.plateCheckStatus = 'match';
        } else if (text === 'not match') {
          this.plateCheckStatus = 'notmatch';
        } else {
          this.plateCheckStatus = 'error';
        }
      } catch (error) {
        this.logApiCall({
          api_name: 'refund_plate_check',
          method: 'POST',
          url: `${baseUrl}/get_post_guicompare_data`,
          request_data: { gui: carNumber },
          error_message: String(error),
        });
        if (seq !== this.plateCheckSeq) return;
        console.error('車號檢核失敗:', error);
        this.plateCheckStatus = 'error';
      } finally {
        clearTimeout(timeout);
      }
    },

    updateCaptchaCode(captchaCode) {
      this.captchaCode = captchaCode; // 更新验证码
    },

    // generateCaptcha() {
    //   // Logic to regenerate the captcha code
    //   const newCaptchaCode = Math.random().toString(36).substring(2, 8).toUpperCase();
    //   this.captchaCode = newCaptchaCode;
    // },
    async handleSubmit() {
      // 檢查必填欄位是否填寫
      const requiredFields = [
        { field: this.name, message: '請填寫姓名', id: 'name' },
        { field: this.carNumber, message: '請填寫車號', id: 'carNumber' },
        { field: this.phone, message: '請填寫聯絡電話', id: 'phone' },
        { field: this.email, message: '請填寫電子郵件', id: 'email' },
        { field: this.idNumber, message: '請填寫身分證字號/統一編號', id: 'idNumber' },
        { field: this.parkingType, message: '請填寫退租原因', id: 'parkingType' },
        { field: this.accountName, message: '請填寫戶名', id: 'accountName' },
        { field: this.bankCode, message: '請填寫銀行代碼', id: 'bankCode' },
        { field: this.branchCode, message: '請填寫分行代碼', id: 'branchCode' },
        { field: this.accountNumber, message: '請填寫匯款帳號', id: 'accountNumber' },
      ];

      for (const { field, message, id } of requiredFields) {
        if (!field) {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.focus();
          }
          alert(message);
          return;
        }
      }

      // 車號檢核：尚未檢核或正在檢核時，先等結果再判斷
      if (this.plateCheckStatus === '' || this.plateCheckStatus === 'checking') {
        await this.checkCarNumber();
      }
      if (this.plateCheckStatus === 'notmatch') {
        const element = document.getElementById('carNumber');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus();
        }
        alert('未查詢到您月票之記錄，請確認車號是否正確。');
        return;
      }

      if (!this.isAgreed) {
        alert('請勾選同意相關事項。');
        return;
      }

      if (this.verificationCode.toLowerCase() !== this.captchaCode.toLowerCase()) {
        // alert('驗證碼錯誤，請重新輸入。' + this.captchaCode + ' ' + this.verificationCode);
        alert('驗證碼錯誤，請重新輸入。');
        // this.generateCaptcha(); // 重新生成验证码
        return;
      }

      // 驗證全部通過後不直接送出，先開啟匯款資料確認視窗。
      // 客訴常見：帳號碼數寫錯、分行未選原開戶分行；退匯需扣第二次手續費 $30。
      this.showBankConfirm = true;
    },

    // 確認視窗按「返回修改」：關閉視窗並帶回匯款資料區塊
    backToEdit() {
      this.showBankConfirm = false;
      const el = document.getElementById('accountName');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },

    // 確認視窗按「確認無誤，送出」才真正送出登記
    async confirmAndSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.doSubmit();
      } finally {
        this.isSubmitting = false;
      }
    },

    async doSubmit() {
      // 直接送到 refund_rent_API 的 /postmethod（原 JSP 表單的後端）
      // 後端以 request.form 讀取（x-www-form-urlencoded），欄位名稱依「退租申請_JSP與API關係」文件對照：
      // 注意 bank_code_1 / bank_branch 是後端實際讀取的名稱（與原 JSP 欄位名不同）
      const branch = this.filteredBranches.find((b) => b[0] === this.branchCode);
      // 送出前再清一次：瀏覽器 autofill 可能繞過 @input 處理，把非預期內容塞進欄位
      // （曾發生驗證碼被併進車號，送出 t96d04RRR5555 導致後端長度判斷失敗）
      const formData = new URLSearchParams({
        master: this.name.trim(),
        carID: this.carNumber.toUpperCase().replace(/[^A-Z0-9]/g, ''),
        tel: this.phone.trim(),
        email: this.email.trim(),
        gui: this.idNumber.trim(),
        refreason: this.parkingType,
        bank_master: this.accountName.trim(),
        // 後端讀取的 form key 是 branch_code99 / branch_name99
        // （bank_code_1 / bank_branch 只是後端接收後的 Python 變數名，不是欄位名）
        branch_code99: this.branchCode, // 7 碼分行代碼 = 3 碼銀行 + 4 碼分行
        // 分行名稱前面帶上銀行名稱，例：合作金庫商業銀行成大分行
        // 客服與匯款單據直接可讀，不必再回頭對銀行代碼
        branch_name99: branch ? this.selectedBankName + branch[1] : '',
        bank_account: this.accountNumber.trim(),
      });

      // 後端只處理 4~7 碼車號，超出範圍會 NameError 並回傳誤導性的「資料不一致」
      const plate = formData.get('carID');
      if (plate.length < 4 || plate.length > 7) {
        alert(`車號格式有誤（目前為 ${plate.length} 碼：${plate}），請確認後重新輸入。`);
        const el = document.getElementById('carNumber');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const baseUrl = process.env.VUE_APP_REFUND_CHECK_API_URL;
      if (!baseUrl) {
        alert('退租申請服務未設定，請聯絡客服。');
        return;
      }

      // ---- 近 30 日重複登記檢查 ----
      // 同姓名＋同車號在 30 日內已登記過時，詢問是否覆蓋前一筆，避免建立第二張退租單。
      // 檢查本身 fail-open：查詢失敗不擋流程，照原本方式送出。
      let overwriteUuid = null;
      try {
        const chkBody = { master: formData.get('master'), carID: formData.get('carID') };
        const chkRes = await fetch(`${baseUrl}/check_recent`, {
          method: 'POST',
          body: JSON.stringify(chkBody),
        });
        const chk = await chkRes.json();
        this.logApiCall({
          api_name: 'refund_check_recent', method: 'POST', url: `${baseUrl}/check_recent`,
          request_data: chkBody, response_data: chk, status_code: chkRes.status,
        });

        if (chk.found) {
          if (!chk.can_overwrite) {
            alert('系統偵測到您近 30 日已有一筆退租登記，且已進入處理程序，無法覆蓋。\n'
              + '如需修改資料，請於週一至週五 09:00~18:00 撥打客服專線 (02)2523-5000，謝謝！');
            return;
          }
          const yes = window.confirm(
            '系統偵測到您已填過退租資料，請問是否要覆蓋前一筆資料，並以本次填寫的內容為主？\n\n'
            + `前次登記時間：${chk.created_on}\n登記編號：${chk.uuid}`
          );
          if (!yes) return;
          overwriteUuid = chk.uuid;
        }
      } catch (e) {
        console.warn('重複登記檢查失敗，照常送出:', e);
      }

      // ---- 覆蓋既有登記 ----
      if (overwriteUuid) {
        const ovBody = { uuid: overwriteUuid, ...Object.fromEntries(formData) };
        try {
          const ovRes = await fetch(`${baseUrl}/overwrite`, {
            method: 'POST',
            body: JSON.stringify(ovBody),
          });
          const ov = await ovRes.json();
          this.logApiCall({
            api_name: 'refund_overwrite', method: 'POST', url: `${baseUrl}/overwrite`,
            request_data: ovBody, response_data: ov, status_code: ovRes.status,
          });
          if (ov.Action) {
            this.currentScreen = 'success';
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            alert('退租登記失敗: ' + (ov.Message || '覆蓋前一筆資料時發生錯誤'));
          }
        } catch (e) {
          this.logApiCall({
            api_name: 'refund_overwrite', method: 'POST', url: `${baseUrl}/overwrite`,
            request_data: ovBody, error_message: String(e),
          });
          alert('退租登記失敗: ' + e);
        }
        return; // 覆蓋流程結束，不再新增一筆
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 後端會寫兩個資料庫並寄兩封信，逾時放寬
      try {
        const response = await fetch(`${baseUrl}/postmethod`, {
          method: 'POST',
          body: formData,
          signal: controller.signal,
        });
        const text = (await response.text()).trim();
        console.log('postmethod response:', text);

        this.logApiCall({
          api_name: 'refund_postmethod',
          method: 'POST',
          url: `${baseUrl}/postmethod`,
          request_data: Object.fromEntries(formData),
          response_data: text,
          status_code: response.status,
        });

        // "cant send mail" 代表兩個資料庫都已寫入成功，只有寄信那步失敗。
        // 正式批次程式 RENTCANCEL_WEB_2_227.py 同樣把它視為成功，此處比照，
        // 避免使用者誤以為失敗而重複送出（後端沒有重複登記限制）。
        if (text.includes('已收到您的退租登記申請') || text.includes('cant send mail')) {
          // 同步寫一份到後台管理系統（best-effort，不影響申請結果）
          this.syncToAdminBackend();

          // 提交成功，显示成功页面
          this.currentScreen = 'success';
          // if success , scroll to top
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          // API 回傳的是純文字錯誤訊息，直接顯示
          alert('退租登記失敗: ' + text);
        }
      } catch (error) {
        this.logApiCall({
          api_name: 'refund_postmethod',
          method: 'POST',
          url: `${baseUrl}/postmethod`,
          request_data: Object.fromEntries(formData),
          error_message: String(error),
        });
        // 捕获错误并提示
        if (error.name === 'AbortError') {
          alert('退租登記逾時，請稍後再試或聯絡客服。');
        } else {
          alert('退租登記失敗: ' + error);
        }
        console.error('Error:', error);
      } finally {
        clearTimeout(timeoutId);
      }
    },

    // 申請成功後，補寫一份到後台管理系統的 rental_cancel_form，讓客服後台也看得到
    // 失敗僅記 log，不影響使用者流程
    async syncToAdminBackend() {
      const payload = {
        name: this.name,
        lp_number: this.carNumber,
        contact_phone: this.phone,
        email: this.email,
        id_number: this.idNumber,
        parking_type: this.parkingType,
        account_name: this.accountName,
        bank_code: this.bankCode,
        branch_code: this.branchCode,
        account_number: this.accountNumber,
        // 必須是「已完成」：批次程式 RENTCANCEL_WEB_2_227.py 會撈所有「待處理」再送一次
        // /postmethod，而本頁已經直接送過了。若標「待處理」會造成同一筆申請建立兩張退租單。
        process_status: "已完成",
        process_comment: "官網線上退租，前端已直接送出 refund_rent_API",
      };
      try {
        await this.pullDAO.addRentalCancel(payload);
      } catch (error) {
        console.error('同步後台失敗（不影響申請）:', error);
      }
    },


  },


};

</script>

<style scoped>
@import "@/css/form.css";

.parking-management-bg {
  width: 100%;
  background-color: var(--background-gray);
  /* padding-bottom: 5rem; */
}

/* 兩列佈局 */
/* 主標題樣式 */
.page-title {
  margin-bottom: 0px;
}


.cancel-container {
  width: 100%;
  background-color: var(--background-gray);
  padding-bottom: 5rem;
}

.plate-check-msg {
  margin: 0.3rem 0 0 0;
  font-size: 14px;
}

.plate-check-msg.checking {
  color: #888888;
}

.plate-check-msg.match {
  color: #2e7d32;
}

.plate-check-msg.notmatch {
  color: #d32f2f;
}

/* 匯款資料欄位標題裡的括號提醒：客人最常填錯的地方，用紅色粗體拉注意 */
.label-note {
  color: #d32f2f;
  font-weight: 700;
}

.agreement-section {
  /* margin-top: 1.5rem; */
  /* padding: 1rem; */
  /* border: 1px solid #ddd; */
  border-radius: 5px;
  /* background-color: f9f9f9; */
}

.agreement-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
}

.agreement-check input[type="checkbox"] {

  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.agreement-section label {
  display: block;
  font-weight: bold;
  /* margin-bottom: 0.5rem; */
}

.agreement-section ul {
  margin: 0;
  padding: 0 1.5rem;
  list-style-type: number;
}

.agreement-section li {
  /* //styleName: md/regular; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

.form-submit-btn {

  margin: 0px;

}

/* .form-select {
  padding: 10px;
  border: 2px solid #ccc;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
  background-color: white;
} */

/* Default ordering for desktop */
.account-name-group {
  order: 1;
}

.bank-code-group {
  order: 2;
}

.account-number-group {
  order: 3;
}

.branch-code-group {
  order: 4;
}

@media screen and (max-width: 768px) {
 

  .agreement-check  input[type="checkbox"] {
    width: 20px;
    height: 20px;

    margin-right: 12px;
  }

  .agreement-section label {
    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .agreement-section ul {
    margin: 0;
    padding: 0px;
    padding-left: 16px;
    padding-right: 0px;
    list-style-type: number;
  }

  .agreement-section li {
    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

}


@media screen and (max-width: 560px) {
 /* Two columns container becomes column layout on mobile */
 .two-columns {
    display: flex;
    flex-direction: column;
  }

  /* Reordering for mobile layout */
  .account-name-group {
    order: 1;
  }

  .account-number-group {
    order: 4;
  }

  .bank-code-group {
    order: 2; /* Move bank code above branch code */
  }

  .branch-code-group {
    order: 3; /* Branch code remains last */
  }
}

/* ---- 匯款資料確認視窗 ---- */
.bank-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.bank-confirm-box {
  background: #fff;
  border-radius: 16px;
  padding: 28px 30px;
  width: 100%;
  max-width: 560px;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  text-align: left;
}

.bank-confirm-title {
  margin: 0 0 18px;
  font-size: 22px;
  font-weight: 700;
  color: var(--gray15);
  text-align: center;
}

.bank-confirm-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.bank-confirm-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.bank-confirm-label {
  font-size: 14px;
  color: var(--gray11);
}

/* 核對重點：24px 以上大粗體 */
.bank-confirm-value {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.4;
  color: var(--gray15);
  word-break: break-all;
}

.bank-confirm-value .code-part {
  margin-right: 12px;
}

/* 帳號加字距，一碼一碼對存摺核對 */
.bank-confirm-value.account-value {
  letter-spacing: 3px;
  font-variant-numeric: tabular-nums;
}

.bank-confirm-short {
  margin: 12px 0 0;
  font-size: 15px;
  font-weight: 700;
  color: #c0392b;
}

.bank-confirm-notice {
  margin: 16px 0 0;
  padding: 12px 14px;
  background: #fdf0ee;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.7;
  color: #c0392b;
}

.bank-confirm-btns {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.bank-confirm-btns .form-submit-btn {
  width: 100%;
  padding: 14px 24px;
  border-radius: 99px;
}

.bank-confirm-btns .form-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media screen and (max-width: 560px) {
  .bank-confirm-box {
    padding: 22px 18px;
  }

  .bank-confirm-value {
    font-size: 24px;
  }
}
</style>
